import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    const $filter = $('.filter-button');
    const $drawer = $('.filter-drawer');
    $filter.on('click', () => {
        const isExpanded = $filter.attr('aria-expanded') === 'true';
        $filter.attr('aria-expanded', !isExpanded);
        $drawer.attr('aria-hidden', isExpanded);
        $drawer.toggleClass('filter-drawer--expand');
    });

    const filterGroup = $drawer.find('[data-filter-group]').data('filterGroup');
    addAction(`filters/values/${filterGroup}`, () => {
        $filter.attr('aria-expanded', true);
        $drawer.attr('aria-hidden', false);
        $drawer.toggleClass('filter-drawer--expand', true);
    });
});
